import styled from 'styled-components'
import TentativeScoringTableBody from './TentativeScoringTableBody'
import TentativeScoringTableHeader from './TentativeScoringTableHeader'

interface TentativeScoringResultTableProps {
  className?: string
}

const TentativeScoringResultTable = ({
  className,
}: TentativeScoringResultTableProps) => {
  return (
    <StyledWrapper className={className}>
      <caption>영역별 응시자 답안 선택 비율</caption>
      <colgroup>
        <col width={136} />
        <col width={136} />
        <col width={136} />
        <col width={82} />
        <col width={82} />
        <col width={82} />
        <col width={82} />
        <col width={82} />
      </colgroup>
      <TentativeScoringTableHeader />
      <TentativeScoringTableBody />
    </StyledWrapper>
  )
}

export default TentativeScoringResultTable

const StyledWrapper = styled.table`
  width: 820px;

  & > caption {
    width: 0;
    height: 0;
    font-size: 0;
  }
`
